import axios from "axios";
import http from "./httpService";

const apiEndpoint = "/export";

export function setExportPassphrase(passphrase) {
  return http.post(`${apiEndpoint}/passphrase`, { passphrase });
}

export function getExportPassphraseStatus() {
  return http.get(`${apiEndpoint}/passphrase/status`);
}

export function generateExportToken() {
  return http.post(`${apiEndpoint}/token`);
}

export function revokeExportToken() {
  return http.delete(`${apiEndpoint}/token`);
}

export function getExportTokenStatus() {
  return http.get(`${apiEndpoint}/token/status`);
}

// Uses the current login session - no export token needed. This is what
// the Settings page's "Download now" button calls.
export function downloadMyExport() {
  return http.get(`${apiEndpoint}/mine`, { responseType: "arraybuffer" });
}

// Uses a standalone export token instead of a login session - for scripts.
export function downloadExport(token) {
  return axios.get(apiEndpoint, {
    headers: { "x-export-token": token },
    responseType: "arraybuffer",
  });
}
